module.exports = __webpack_public_path__ + "static/img/3 2016.8 多轴运动控制系统研发中心.68311f0d.png";